<template>
  <div>
    <h2 class="text-lg font-bold uppercase tracking-wide">
      Follow me
    </h2>

    <div class="mt-4 grid grid-flow-row gap-1">
      <a class="inline-flex items-center gap-2 py-1 text-sm hover:underline" href="https://twitter.com/filip_hric">
        <IconTwitter class="w-4" />
        <span>Twitter</span>
      </a>
      <a class="inline-flex items-center gap-2 py-1 text-sm hover:underline" href="https://www.linkedin.com/in/filip-hric">
        <IconLinkedin class="w-4" />
        <span>LinkedIn</span>
      </a>
      <a class="inline-flex items-center gap-2 py-1 text-sm hover:underline" href="https://bsky.app/profile/filiphric.com">
        <IconBluesky class="w-4" />
        <span>Bluesky</span>
      </a>
      <a class="inline-flex items-center gap-2 py-1 text-sm hover:underline" href="https://www.threads.net/@filiphric_">
        <IconThreads class="w-4" />
        <span>Threads</span>
      </a>
      <a class="inline-flex items-center gap-2 py-1 text-sm hover:underline" href="https://discord.com/invite/3MdvPfT">
        <IconDiscord class="w-4" />
        <span>Discord</span>
      </a>
      <a class="inline-flex items-center gap-2 py-1 text-sm hover:underline" href="https://github.com/filiphric">
        <IconGithub class="w-4" />
        <span>GitHub</span>
      </a>
      <a class="inline-flex items-center gap-2 py-1 text-sm hover:underline" href="https://www.youtube.com/@filip_hric">
        <IconYoutube class="w-4" />
        <span>YouTube</span>
      </a>
      <a class="inline-flex items-center gap-2 py-1 text-sm hover:underline" href="/rss.xml">
        <IconRss class="w-4" />
        <span>RSS feed</span>
      </a>
    </div>
  </div>
</template>
